import { render, staticRenderFns } from "./JUploadDragger.vue?vue&type=template&id=bd1277c0"
import script from "./JUploadDragger.vue?vue&type=script&lang=js"
export * from "./JUploadDragger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports